import React from 'react';

export default function MarbleCard({ id, name, image, description, type, onClick }) {
    return (
        <div className="marble-card">
            <div className="card-image-wrapper">
                <img src={image} alt={name} className="card-image" />
            </div>
            <div className="card-content">
                <h3 className="card-title">{name}</h3>
                <p className="card-type">{type}</p>
                <p className="card-description">{description}</p>
            </div>
        </div>
    );
}
